// apiConfig.ts
// const API_BASE_URL = 'https://kanemaonline.com/clone';
const API_BASE_URL = 'https://kanema.staticcomputersinc.com/api';
export default API_BASE_URL;
